export default "__VITE_ASSET__DUKuzhTh__"